import React from 'react';
import { TutorialModal, TutorialStep, isTutorialCompleted } from './TutorialModal';

const HUNTER_TUTORIAL_KEY = 'hunter';

const hunterSteps: TutorialStep[] = [
  {
    title: 'Welcome, Hunter!',
    bullets: [
      'Find hidden items placed by the hiders',
      'Navigate to each Pin location in order',
      'Mark items as found when you discover them',
      'Complete all Pins to finish the hunt',
    ],
    image: '/tutorial/hunter-1.png',
  },
  {
    title: 'Wait for Setup',
    bullets: [
      'Hiders are placing items at secret locations',
      'Wait for all hiders to finish and press ready',
      'When prompted, press "I\'m Ready" to begin',
      'The hunt starts once everyone confirms',
    ],
    image: '/tutorial/hunter-2.png',
  },
  {
    title: 'Follow the Compass',
    bullets: [
      'A compass appears in the center of your screen',
      'It always points toward the next Pin',
      'Follow the direction to reach each location',
      'Trust the compass — it knows the way',
    ],
    image: '/tutorial/hunter-3.png',
  },
  {
    title: 'Watch the Glow',
    bullets: [
      'The compass glows brighter as you get closer',
      'A faint glow means you\'re far away',
      'A bright glow means you\'re getting warm',
      'Pay attention to the intensity changes',
    ],
    image: '/tutorial/hunter-4.png',
  },
  {
    title: 'Enter the Zone',
    bullets: [
      "When the compass turns yellow and is replaced by a circular image, you're in the zone",
      'Hidden items are somewhere within this area',
      'Start searching your surroundings carefully',
      'Stay aware of your environment and safety',
    ],
    image: '/tutorial/hunter-5.png',
  },
  {
    title: 'Find and Mark Items',
    bullets: [
      'Search the area for hidden items',
      'Tap one of the buttons at the bottom of the screen when you discover an item',
      'A hider will validate your find',
      'Keep searching until all items are marked',
      'Pay close attention to the area, you may need more than just the items at each pin',
    ],
    image: '/tutorial/hunter-6.png',
  },
  {
    title: 'Complete and Continue',
    bullets: [
      'After finding all items, press "Complete"',
      'If nothing interrupts you, you\'ll move on to the next Pin',
      'The compass will guide you to the next Pin',
      'Repeat the process for each location',
      'The final Pin holds the grand treasure',
    ],
    image: '/tutorial/hunter-7.png',
  },
  {
    title: 'Stay Safe',
    bullets: [
      'Always watch your surroundings',
      "Don't enter restricted or dangerous areas",
      'Stay with your group if hunting together',
      'Have fun, but stay alert',
    ],
    image: '/tutorial/hunter-8.png',
  },
  {
    title: "You're Ready!",
    bullets: [
      'Follow the compass to each Pin',
      "Brighter glow means you're closer",
      "Yellow circle means you're in the zone",
      'Find all items, press Complete, and continue!',
    ],
    image: '/tutorial/hunter-9.png',
  },
];

interface HunterTutorialProps {
  isOpen: boolean;
  onClose: () => void;
  onComplete: () => void;
}

/**
 * Hunter onboarding tutorial
 */
export const HunterTutorial: React.FC<HunterTutorialProps> = ({
  isOpen,
  onClose,
  onComplete,
}) => {
  return (
    <TutorialModal
      isOpen={isOpen}
      onClose={onClose}
      onComplete={onComplete}
      steps={hunterSteps}
      tutorialKey={HUNTER_TUTORIAL_KEY}
    />
  );
};

/**
 * Check if the hunter tutorial has been completed
 */
export function isHunterTutorialCompleted(): boolean {
  return isTutorialCompleted(HUNTER_TUTORIAL_KEY);
}

export default HunterTutorial;
